import {Tag, tagTypes} from "../../../common/components/Tag.jsx";

import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

export default class ProductsDisplay extends React.PureComponent {
    constructor(props){
        super(props);
    }
    
    render(){
        const {
            localization,
            products,
            useText,
            count,
        } = this.props;
        const width = 3;
        const components = [];

        for(let i=0; i<3; i++){
            for(let j=0; j<width; j++){
                const prdIndex = i*3+j;
                components[components.length] = (
                    <div className="product-display-item" key={i*3+j} style={{
                        borderRight:j+1<width?"1px solid #edeef2":undefined,
                        borderBottom:i<2?"1px solid #edeef2":undefined
                    }}>
                        {products && products.length>prdIndex && products[prdIndex].product && products[prdIndex].product.imageUrl && (
                            <img src={products[prdIndex].product.imageUrl} className="product-image"/>
                        )}
                    </div>
                );
            }
        }
        return (
            <div className="product-display-wrapper" style={{width:`${65*width+2}px`, height:"197px"}}>
                {components}
                {count>0 && (
                    <div className="product-display-tag-wrapper">
                        <Tag type={tagTypes.red} label={localization.text(...useText,{count:count})} className="product-display-tag" />
                    </div>
                )}
            </div>
        );
    }
}
ProductsDisplay.propTypes = {
    localization: Localization.propTypes.isRequired,
    count: PropTypes.number.isRequired,
    products: PropTypes.array.isRequired,
    useText: PropTypes.array,
};

ProductsDisplay.defaultProps = {
    useText: ["dashboard","xProducts"]
};